import React, {useState} from 'react'
import {Form, Input, Button} from 'antd'
import {UserOutlined, LockOutlined} from '@ant-design/icons'
import {observer, inject} from 'mobx-react'
import {login} from '@apis'
import ydLogo from '@assets/img/ydIcon.png'
import './index.less'

const FormItem = Form.Item

const Login = inject('store')(
  observer(({store, history}) => {
    const [loading, setLoading] = useState(false)

    async function submitAction(params) {
      try {
        setLoading(true)
        const res = await login({
          ...params,
          "verifyType": "verifyPassword"
        })
        console.log('res--', res)
        localStorage.setItem('fs_username', params.userName)
        history.push('/overview')
      } catch (e) {
        setLoading(false)
      }
    }

    return (
      <div className="login-main">
        <div className="ck-title">
          勇电智慧照明管理云平台
          <span class="empty-sp" />
        </div>
        <div className="light-login">
          <span className="login-title">用户登录</span>
          <Form
            onFinish={submitAction}
            initialValues={{
              userName: localStorage.getItem('fs_username')
            }}
            className="form-login"
          >
            <FormItem
              rules={
                [{
                  required: true, message: '用户名不能为空'
                }]
              }
              name="userName"
            >
              <Input
                placeholder="用户名"
                autoComplete="off"
                className="form-input"
                prefix={<UserOutlined style={{color: '#19DDDE'}} />}
              />
            </FormItem>
            <FormItem
              rules={
                [{
                  required: true, message: '密码不能为空'
                }]
              }
              name="code"
            >
              <Input
                type="password"
                placeholder="密码"
                className="form-input"
                prefix={<LockOutlined style={{color: '#19DDDE'}} />}
              />
            </FormItem>
            <FormItem>
              <Button
                type="primary"
                htmlType="submit"
                className="login-btn"
                loading={loading}
              >
                  登录
              </Button>
            </FormItem>
          </Form>
        </div>
        <div className="yd-logo">
          <img src={ydLogo} alt="" className="yd-logo-img" />
        </div>
        <div className="copy-right">
          勇电智慧照明管理云平台V1.0.1 @2021-09-15 版权所有: 杭州勇电照明有限公司
        </div>
      </div>
    )
  })
)

export default Login